import { useEffect, useState } from "react";
import { Button, required, useNotify, useRefresh } from "react-admin";
import { useWatch } from "react-hook-form";
import SyncIcon from "@mui/icons-material/Sync";
import ProfessorInput from "server/components/Fields/ProfessorInput";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";

const ProfessorFormField = ({ currentProfessorId, onChangedChange }) => {
  const professorId = useWatch({ name: "professorId" });

  useEffect(() => {
    onChangedChange(professorId !== currentProfessorId);
  }, [professorId, currentProfessorId, onChangedChange]);

  return (
    <ProfessorInput
      source="professorId"
      validate={required()}
      fullWidth
    />
  );
};

const ChangeProfessorDialog = ({ record }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [isProfessorChanged, setIsProfessorChanged] = useState(false);

  const handleConfirm = async data => {
    await dataProvider.customRequest(
      studentRequests.updateClassProfessor(record.id),
      { ProfessorEmployeeId: data.professorId },
      "PUT",
    );
    notify("Преподавателят е сменен успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Смяна на преподавател"
      onConfirm={handleConfirm}
      defaultValues={{ professorId: record.professorId }}
      confirmEnabled={isProfessorChanged}
      resetProps={() => setIsProfessorChanged(false)}
      triggerButton={
        <Button
          label="Смяна на преподавател"
          color="primary"
          startIcon={<SyncIcon />}
        />
      }
    >
      <ProfessorFormField
        currentProfessorId={record.professorId}
        onChangedChange={setIsProfessorChanged}
      />
    </FormModal>
  );
};

export default ChangeProfessorDialog;
